<template>
    <div :class="wrapperClasses">
        <v-menu
            ref="menu"
            v-model="periodMenu"
            :close-on-content-click="false"
            :return-value.sync="period"
            transition="scale-transition"
            offset-y
            :class="menuClasses"
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :class="buttonClasses"
                    v-bind="attrs"
                    v-on="on">
                    Perioada {{ periodText }}
                </v-btn>
            </template>
            <v-date-picker
                v-model.lazy="period"
                first-day-of-week="1"
                show-adjacent-months
                range
            >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="periodMenu = false"
                >
                    Anulare
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(period)"
                >
                    {{ applyButtonText }}
                </v-btn>
            </v-date-picker>
        </v-menu>
    </div>
</template>
<script>
    import debounce from 'lodash/debounce'
    export default {
        props: {
            value: {
                type: Array,
                default () {
                    return [window.moment().toISOString(), window.moment().toISOString()]
                }
            },
            applyButtonText: {
                type: String,
                default() {
                    return 'Filtrare'
                }
            },
            wrapperClasses: {
                type: [String, Array],
                default() {
                    return ''
                }
            },
            menuClasses: {
                type: [String, Array],
                default() {
                    return 'py-0'
                }
            },
            buttonClasses: {
                type: [String, Array],
                default() {
                    return []
                }
            }
        },
        data: function () {
            return {
                period: this.value,
                periodMenu: false,
            }
        },
        watch: {
            period: {
                handler: debounce(function (val) {
                    if(val.length === 2) {
                        this.$emit('input', val)
                    }
                }, 500)
            },
            value: {
                handler(val) {
                    if(val.length === 2) {
                        this.period = val
                    }
                }
            }
        },
        computed: {
            periodText() {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            }
        }
    }
</script>
